import React from "react";
import { Outlet } from "react-router-dom";

const CityRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default CityRoot;
